import React from 'react';
import useWidget from '@Utils/core/useWidget';
import { WidgetId } from '@Utils/edge/constants';
import Steps from './components/Steps';
import Tooltip from '@Utils/shared/components/RaidIdTooltip/Tooltip';
import {
  TooltipContextProvider,
  useTooltipContextValue,
} from '@Utils/shared/components/RaidIdTooltip/tooltipContext';

const LogoMakerThankYou: React.FC = () => {
  const { images, strings } = useWidget(WidgetId.LogoMakerThankYouRaidIdV3);
  const tooltipContextValue = useTooltipContextValue();

  return (
    <>
      <TooltipContextProvider value={tooltipContextValue}>
        <Steps />
        <Tooltip
          title={strings.tooltipTitle}
          description={strings.tooltipDescription}
          screenShot1={images.tooltipScreenshotStep1.src}
          screenShot2={images.tooltipScreenshotStep2.src}
        />
      </TooltipContextProvider>
    </>
  );
};

export default LogoMakerThankYou;
